import type { TrackingConsentLocale } from './types';

const locale: TrackingConsentLocale = {
  copy: {
    title: 'Използваме бисквитки',
    description:
      'Използваме бисквитки и подобни технологии, за да осигурим работата на тази платформа. Строго необходимите бисквитки са винаги активни.',
    allow_label: 'Приемане на всички бисквитки',
    reject_label: 'Само строго необходимите',
    settings_label: 'Настройки за бисквитките',
    policy_link_label: 'Политика за поверителност и бисквитки',
    categories_label: 'Категории',
    always_on_label: 'Винаги активни',
    required_label: 'Задължителни',
    save_preferences_label: 'Запазване на предпочитанията',
    close_label: 'Затваряне',
    allow_all_optional_categories_label: 'Разрешаване на всички незадължителни категории',
    save_error: 'Не успяхме да запазим избора ви за поверителност. Моля, опитайте отново.'
  },
  categories: {
    strictly_necessary: {
      name: 'Строго необходими',
      purpose: 'Необходими са за работата на тази платформа и не могат да бъдат изключени.'
    },
    analytics: {
      name: 'Анализи',
      purpose: 'Измерват как посетителите използват тази платформа, за да се подобри работата ѝ.'
    },
    marketing: { name: 'Маркетинг', purpose: 'Поддържат рекламата и маркетинга, избрани от организатора.' }
  }
};

export default locale;
